<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>EDIT - FARM MANAGEMENT</h2>
       <p>Edit Farm record</p>
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <form class="row">
       <div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group">
       <label for="Note">Farm Name</label>
       
        <input type="text" id="farmname" name="adddose" value="" class="form-control">
    
       </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
        <label for="Note">Farm User ID</label>
 
         <input type="text" id="farmid" name="adddose" value="" class="form-control">

        </div>
        </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
        <label for="Note">Contact Person</label>

       <input type="text" id="farmcontactname" class="form-control" value="" >

       </div>
      </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group">
       <label for="Note">Contact Email</label>
       <input type="text"  class="form-control" id="farmcontactemail" value="" >
       </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group ">
       <label for="Note">Contact Number</label>
       <input type="text" class="form-control" id="ContactNumber" >
       </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group ">
       <label for="Note">Address</label>
       <input type="text" class="form-control" id="Address" >
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <a (click)=farmsmanagement() class="btn btn-fill btn-primary mb-3">Submit
       <div class="ripple-container"></div></a>
       <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
       </div>
       </form>
     </div>
   </div>
 </div>
